import z from "zod";

export const HFCSubTypes = z.enum(["single", "spread", "fly", "condor"]);
export type THFCSubType = z.infer<typeof HFCSubTypes>;

export const monthLabels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const HFCMonths = z.enum(monthLabels);
export type THFCMonth = z.infer<typeof HFCMonths>;

export const HFCMonthsSchema = z.array(HFCMonths);
export type THFCMonths = z.infer<typeof HFCMonthsSchema>;

export const HFCRelativeYear = z.enum([
  "Y(-8)",
  "Y(-7)",
  "Y(-6)",
  "Y(-5)",
  "Y(-4)",
  "Y(-3)",
  "Y(-2)",
  "Y(-1)",
  "Y(0)",
  "Y(+1)",
  "Y(+2)",
]);
export type THFCRelativeYear = z.infer<typeof HFCRelativeYear>;

export const relativeMonthLabels = [
  "M0",
  "M1",
  "M2",
  "M3",
  "M4",
  "M5",
  "M6",
  "M7",
  "M8",
  "M9",
  "M10",
  "M11",
  "M12",
  "M13",
  "M14",
  "M15",
  "M16",
  "M17",
  "M18",
  "M19",
  "M20",
  "M21",
  "M22",
  "M23",
  "M24",
];
export const HFCRelativeMonth = z.enum(relativeMonthLabels);
export type THFCRelativeMonth = z.infer<typeof HFCRelativeMonth>;

export const HFCRelativeYearsSchema = z.array(HFCRelativeYear);
export type THFCRelativeYears = z.infer<typeof HFCRelativeYearsSchema>;
export const HFCSpreadSchema = z.object({
  productA: z.string(),
  productB: z.string(),
  productOperator: z.enum(["-", "/"]),
  monthType: z.enum(["relative", "absolute"]),
  monthA: z.string(),
  monthB: z.string(),
  operatorA: z.enum(["+", "-", "*", "/"]),
  operatorB: z.enum(["+", "-", "*", "/"]),
  coefficientA: z.number(),
  coefficientB: z.number(),
});
export type THFCSpread = z.infer<typeof HFCSpreadSchema>;
export const HFCChartsSchema = z.object({
  id: z.string(),
  idx: z.string().optional(),
  chartSubType: HFCSubTypes,
  productId: z.string(),
  months: HFCMonthsSchema.optional(), // e.g. ["Jan", "Feb", "Mar"]
  relativeMonths: z.array(HFCRelativeMonth).optional(), // e.g. ["M0", "M1", "M2"]
  offsetMonths: z.array(z.string()).optional(), // e.g. ["Apr+1", "Jan+2"] for Fly/Condor
  years: z.array(z.number()).optional(), // e.g. [2020, 2021, 2022]
  relativeYears: HFCRelativeYearsSchema.optional(), // e.g. ["Y(-1)", "Y(0)", "Y(+1)"]
  range: z.enum(["12", "24"]),
  spread: HFCSpreadSchema.optional(), // For Spread charts
});
export type THFCChart = z.infer<typeof HFCChartsSchema>;
export const HFC_LINE_COLORS = {
  2010: "#C7C7C7",
  2011: "#FF9896",
  2012: "#AEC7E8",
  2013: "#DBDB8D",
  2014: "#C5B0D5",
  2015: "#FFBB78",
  2016: "#98DF8A",
  2017: "#C49C94",
  2018: "#9EDAE5",
  2019: "#F7B6D2",
  2020: "#17BECF",
  2021: "#D62728",
  2022: "#8C564B",
  2023: "#2CA02C",
  2024: "#9467BD",
  2025: "#FF7F0E",
  2026: "#1F77B4",
  2027: "#E377C2",
  2028: "#7F7F7F",
  2029: "#BCBD22",
  2030: "#FBC15E",
} as const satisfies Record<number, string>;
